import { zetApi } from '@zet/network'

import { IShowBottomSheetResponse, IShownBottomSheet } from './types'

export async function showPrompt() {
  const { data } = await zetApi.get<IShowBottomSheetResponse>('/prompts')
  return data?.data
}

export async function shownPrompt(data: IShownBottomSheet) {
  const { data: response } = await zetApi.post('/prompts', data)
  return response?.data
}
